const Component = {
  render: function render() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      'div',
      [
        _c('h1', { staticClass: 'uk-h1 tm-heading-fragment' }, [
          _vm._v('Tooltip')
        ]),
        _c('p', { staticClass: 'uk-text-lead' }, [
          _vm._v('Easily create a nice looking tooltip.')
        ]),
        _vm._v(' '),
        _vm._m(0),
        _vm._m(1),
        _vm._v(' '),
        _vm._m(2),
        _c('md-code-example-122'),
        _c(
          'p',
          [
            _c('vk-label', [_vm._v('Note')]),
            _vm._v(' '),
            _c('code', [_vm._v('title')]),
            _vm._v(' is the '),
            _c('em', [_vm._v('primary')]),
            _vm._v(
              " option and its key may be omitted if it's the only option in the directive value."
            )
          ],
          1
        ),
        _vm._v(' '),
        _c('hr', { staticClass: 'uk-margin-large' }),
        _vm._m(3),
        _vm._m(4),
        _vm._v(' '),
        _vm._m(5),
        _vm._m(6),
        _c('md-code-example-123'),
        _c('hr', { staticClass: 'uk-margin-large' }),
        _vm._m(7),
        _vm._m(8),
        _vm._v(' '),
        _vm._m(9),
        _c('md-code-example-124'),
        _c('hr', { staticClass: 'uk-margin-large' }),
        _vm._m(10),
        _vm._m(11),
        _vm._v(' '),
        _vm._m(12),
        _c('md-code-example-125'),
        _c('hr', { staticClass: 'uk-margin-large' }),
        _vm._m(13),
        _vm._m(14),
        _c(
          'p',
          [
            _c('vk-label', [_vm._v('Note')]),
            _vm._v(
              ' You can learn about directives and how to apply options at the '
            ),
            _c(
              'router-link',
              { staticClass: 'tm-internal-link', attrs: { to: 'directives' } },
              [_vm._v('Directives guide')]
            ),
            _vm._v('.')
          ],
          1
        )
      ],
      1
    )
  },
  staticRenderFns: [
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c(
        'h2',
        { staticClass: 'uk-h2 tm-heading-fragment', attrs: { id: 'usage' } },
        [_c('a', { attrs: { href: '#usage' } }, [_vm._v('Usage')])]
      )
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('p', [
        _vm._v('Set the '),
        _c('code', [_vm._v('v-vk-tooltip')]),
        _vm._v(' directive with a '),
        _c('code', [_vm._v('title')]),
        _vm._v(' to apply a tooltip to an element.')
      ])
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('div', { staticClass: 'uk-margin-medium' }, [
        _c('pre', [
          _c('code', { staticClass: 'lang-html hljs' }, [
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('<'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('span')]),
              _vm._v(' '),
              _c('span', { staticClass: 'hljs-attr' }, [
                _vm._v('v-vk-tooltip')
              ]),
              _vm._v('='),
              _c('span', { staticClass: 'hljs-string' }, [
                _vm._v('"\'Hello World\'"')
              ]),
              _vm._v('>')
            ]),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('</'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('span')]),
              _vm._v('>')
            ])
          ])
        ])
      ])
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c(
        'h2',
        {
          staticClass: 'uk-h2 tm-heading-fragment',
          attrs: { id: 'alignment' }
        },
        [_c('a', { attrs: { href: '#alignment' } }, [_vm._v('Alignment')])]
      )
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('p', [
        _vm._v(
          'Change the tooltip default alignment with a modifier or an option, where the later takes preference. The default value is '
        ),
        _c('code', [_vm._v('top')]),
        _vm._v('.')
      ])
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('div', { staticClass: 'uk-margin-medium' }, [
        _c('pre', [
          _c('code', { staticClass: 'lang-html hljs' }, [
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('<'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('vk-button')]),
              _vm._v(' '),
              _c('span', { staticClass: 'hljs-attr' }, [
                _vm._v('v-vk-tooltip.topLeft')
              ]),
              _vm._v('='),
              _c('span', { staticClass: 'hljs-string' }, [
                _vm._v('"\'Hello World\'"')
              ]),
              _vm._v('>')
            ]),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('</'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('vk-button')]),
              _vm._v('>')
            ])
          ])
        ])
      ])
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('div', { staticClass: 'uk-overflow-auto' }, [
        _c('table', { staticClass: 'uk-table uk-table-divider' }, [
          _c('thead', [
            _c('tr', [
              _c('th', { staticStyle: { 'text-align': 'left' } }, [
                _vm._v('Position')
              ]),
              _vm._v(' '),
              _c('th', { staticStyle: { 'text-align': 'left' } }, [
                _vm._v('Description')
              ])
            ])
          ]),
          _vm._v(' '),
          _c('tbody', [
            _c('tr', [
              _c('td', { staticStyle: { 'text-align': 'left' } }, [
                _c('code', [_vm._v('top')])
              ]),
              _vm._v(' '),
              _c('td', { staticStyle: { 'text-align': 'left' } }, [
                _vm._v('Aligns the tooltip to the top.')
              ])
            ]),
            _vm._v(' '),
            _c('tr', [
              _c('td', { staticStyle: { 'text-align': 'left' } }, [
                _c('code', [_vm._v('topLeft')])
              ]),
              _vm._v(' '),
              _c('td', { staticStyle: { 'text-align': 'left' } }, [
                _vm._v('Aligns the tooltip to the top left.')
              ])
            ]),
            _vm._v(' '),
            _c('tr', [
              _c('td', { staticStyle: { 'text-align': 'left' } }, [
                _c('code', [_vm._v('topRight')])
              ]),
              _vm._v(' '),
              _c('td', { staticStyle: { 'text-align': 'left' } }, [
                _vm._v('Aligns the tooltip to the top right.')
              ])
            ]),
            _vm._v(' '),
            _c('tr', [
              _c('td', { staticStyle: { 'text-align': 'left' } }, [
                _c('code', [_vm._v('bottom')])
              ]),
              _vm._v(' '),
              _c('td', { staticStyle: { 'text-align': 'left' } }, [
                _vm._v('Aligns the tooltip to the bottom.')
              ])
            ]),
            _vm._v(' '),
            _c('tr', [
              _c('td', { staticStyle: { 'text-align': 'left' } }, [
                _c('code', [_vm._v('bottomLeft')])
              ]),
              _vm._v(' '),
              _c('td', { staticStyle: { 'text-align': 'left' } }, [
                _vm._v('Aligns the tooltip to the bottom left.')
              ])
            ]),
            _vm._v(' '),
            _c('tr', [
              _c('td', { staticStyle: { 'text-align': 'left' } }, [
                _c('code', [_vm._v('bottomRight')])
              ]),
              _vm._v(' '),
              _c('td', { staticStyle: { 'text-align': 'left' } }, [
                _vm._v('Aligns the tooltip to the bottom right.')
              ])
            ]),
            _vm._v(' '),
            _c('tr', [
              _c('td', { staticStyle: { 'text-align': 'left' } }, [
                _c('code', [_vm._v('left')])
              ]),
              _vm._v(' '),
              _c('td', { staticStyle: { 'text-align': 'left' } }, [
                _vm._v('Aligns the tooltip to the left.')
              ])
            ]),
            _vm._v(' '),
            _c('tr', [
              _c('td', { staticStyle: { 'text-align': 'left' } }, [
                _c('code', [_vm._v('right')])
              ]),
              _vm._v(' '),
              _c('td', { staticStyle: { 'text-align': 'left' } }, [
                _vm._v('Aligns the tooltip to the right.')
              ])
            ])
          ])
        ])
      ])
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c(
        'h2',
        {
          staticClass: 'uk-h2 tm-heading-fragment',
          attrs: { id: 'animation' }
        },
        [_c('a', { attrs: { href: '#animation' } }, [_vm._v('Animation')])]
      )
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('p', [
        _vm._v('Use one of the animations from the '),
        _c(
          'a',
          {
            attrs: {
              href: 'https://getuikit.com/docs/animation',
              target: '_blank'
            }
          },
          [_vm._v('UIkit Animation component')]
        ),
        _vm._v(' with the '),
        _c('code', [_vm._v('animation')]),
        _vm._v(
          ' option to customize the in and out animations, without prefixes. Separate the animation out with a space and control the duration with the '
        ),
        _c('code', [_vm._v('duration')]),
        _vm._v(' option.')
      ])
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('div', { staticClass: 'uk-margin-medium' }, [
        _c('pre', [
          _c('code', { staticClass: 'lang-html hljs' }, [
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('<'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('div')]),
              _vm._v(' '),
              _c('span', { staticClass: 'hljs-attr' }, [
                _vm._v('v-vk-tooltip')
              ]),
              _vm._v('='),
              _c('span', { staticClass: 'hljs-string' }, [
                _vm._v(
                  "\"{ \n  title: 'Hello World', \n  animation: 'scale-up fade', \n  duration: 1000 \n}\""
                )
              ]),
              _vm._v('>')
            ]),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('</'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('div')]),
              _vm._v('>')
            ])
          ])
        ])
      ])
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c(
        'h2',
        { staticClass: 'uk-h2 tm-heading-fragment', attrs: { id: 'delay' } },
        [_c('a', { attrs: { href: '#delay' } }, [_vm._v('Delay')])]
      )
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('p', [
        _vm._v(
          'If you want the tooltip to appear with a little delay, add the '
        ),
        _c('code', [_vm._v('delay')]),
        _vm._v(' option in milliseconds.')
      ])
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('div', { staticClass: 'uk-margin-medium' }, [
        _c('pre', [
          _c('code', { staticClass: 'lang-html hljs' }, [
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('<'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('div')]),
              _vm._v(' '),
              _c('span', { staticClass: 'hljs-attr' }, [
                _vm._v('v-vk-tooltip')
              ]),
              _vm._v('='),
              _c('span', { staticClass: 'hljs-string' }, [
                _vm._v('"{ title: \'Hello World\', delay: 500 }"')
              ]),
              _vm._v('>')
            ]),
            _c('span', { staticClass: 'hljs-tag' }, [
              _vm._v('</'),
              _c('span', { staticClass: 'hljs-name' }, [_vm._v('div')]),
              _vm._v('>')
            ])
          ])
        ])
      ])
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c(
        'h2',
        { staticClass: 'uk-h2 tm-heading-fragment', attrs: { id: 'options' } },
        [_c('a', { attrs: { href: '#options' } }, [_vm._v('Options')])]
      )
    },
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('div', { staticClass: 'uk-overflow-auto' }, [
        _c('table', { staticClass: 'uk-table uk-table-divider' }, [
          _c('thead', [
            _c('tr', [
              _c('th', [_vm._v('Name')]),
              _vm._v(' '),
              _c('th', [_vm._v('Type')]),
              _vm._v(' '),
              _c('th', [_vm._v('Default')]),
              _vm._v(' '),
              _c('th', [_vm._v('Description')])
            ])
          ]),
          _vm._v(' '),
          _c('tbody', [
            _c('tr', [
              _c('td', [_c('code', [_vm._v('title')])]),
              _vm._v(' '),
              _c('td', [_vm._v('String')]),
              _vm._v(' '),
              _c('td', [_vm._v('--')]),
              _vm._v(' '),
              _c('td', [
                _vm._v('Tooltip main text. Is the '),
                _c('em', [_vm._v('primary')]),
                _vm._v(' option.')
              ])
            ]),
            _vm._v(' '),
            _c('tr', [
              _c('td', [_c('code', [_vm._v('position')])]),
              _vm._v(' '),
              _c('td', [_vm._v('String')]),
              _vm._v(' '),
              _c('td', [_c('code', [_vm._v('top')])]),
              _vm._v(' '),
              _c('td', [_vm._v('Tooltip position relative to the element.')])
            ]),
            _vm._v(' '),
            _c('tr', [
              _c('td', [_c('code', [_vm._v('offset')])]),
              _vm._v(' '),
              _c('td', [_vm._v('Number')]),
              _vm._v(' '),
              _c('td', [_c('code', [_vm._v('false')])]),
              _vm._v(' '),
              _c('td', [_vm._v('The offset of the Tooltip.')])
            ]),
            _vm._v(' '),
            _c('tr', [
              _c('td', [_c('code', [_vm._v('animation')])]),
              _vm._v(' '),
              _c('td', [_vm._v('String')]),
              _vm._v(' '),
              _c('td', [_c('code', [_vm._v('scale-up')])]),
              _vm._v(' '),
              _c('td', [
                _vm._v(
                  'The display animations. Comma separate for animation out.'
                )
              ])
            ]),
            _vm._v(' '),
            _c('tr', [
              _c('td', [_c('code', [_vm._v('duration')])]),
              _vm._v(' '),
              _c('td', [_vm._v('Number')]),
              _vm._v(' '),
              _c('td', [_c('code', [_vm._v('100')])]),
              _vm._v(' '),
              _c('td', [_vm._v('The animation duration.')])
            ]),
            _vm._v(' '),
            _c('tr', [
              _c('td', [_c('code', [_vm._v('delay')])]),
              _vm._v(' '),
              _c('td', [_vm._v('Number')]),
              _vm._v(' '),
              _c('td', [_c('code', [_vm._v('0')])]),
              _vm._v(' '),
              _c('td', [_vm._v('The show delay.')])
            ]),
            _vm._v(' '),
            _c('tr', [
              _c('td', [_c('code', [_vm._v('cls')])]),
              _vm._v(' '),
              _c('td', [_vm._v('String')]),
              _vm._v(' '),
              _c('td', [_c('code', [_vm._v('uk-active')])]),
              _vm._v(' '),
              _c('td', [_vm._v('The active class.')])
            ])
          ])
        ])
      ])
    }
  ],
  data: function() {
    return {}
  },
  scrollToTop: true,
  sections: [
    { id: 'usage', title: 'Usage' },
    { id: 'alignment', title: 'Alignment' },
    { id: 'animation', title: 'Animation' },
    { id: 'delay', title: 'Delay' },
    { id: 'options', title: 'Options' }
  ],
  components: {
    'md-code-example-122': {
      render: function render() {
        var _vm = this
        var _h = _vm.$createElement
        var _c = _vm._self._c || _h
        return _c(
          'div',
          { staticClass: 'uk-position-relative uk-margin-medium' },
          [
            _c(
              'vk-tabs',
              { staticClass: 'uk-margin' },
              [
                _c(
                  'vk-tabs-item',
                  { attrs: { title: 'Preview' } },
                  [
                    _c(
                      'vk-button',
                      {
                        directives: [
                          {
                            name: 'vk-tooltip',
                            rawName: 'v-vk-tooltip',
                            value: 'Hello World',
                            expression: "'Hello World'"
                          }
                        ]
                      },
                      [_vm._v('Hover')]
                    )
                  ],
                  1
                ),
                _vm._v(' '),
                _c('vk-tabs-item', { attrs: { title: 'Markup' } }, [
                  _c('pre', [
                    _c(
                      'code',
                      { staticClass: 'lang-html hljs', attrs: { id: '122' } },
                      [
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-button')
                          ]),
                          _vm._v(' '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v('v-vk-tooltip')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"\'Hello World\'"')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('Hover'),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-button')
                          ]),
                          _vm._v('>')
                        ])
                      ]
                    )
                  ])
                ])
              ],
              1
            )
          ],
          1
        )
      },
      data: function() {
        return {}
      }
    },
    'md-code-example-123': {
      render: function render() {
        var _vm = this
        var _h = _vm.$createElement
        var _c = _vm._self._c || _h
        return _c(
          'div',
          { staticClass: 'uk-position-relative uk-margin-medium' },
          [
            _c(
              'vk-tabs',
              { staticClass: 'uk-margin' },
              [
                _c('vk-tabs-item', { attrs: { title: 'Preview' } }, [
                  _c(
                    'p',
                    {
                      directives: [
                        { name: 'vk-margin', rawName: 'v-vk-margin' }
                      ]
                    },
                    [
                      _c(
                        'vk-button',
                        {
                          directives: [
                            {
                              name: 'vk-tooltip',
                              rawName: 'v-vk-tooltip',
                              value: 'Hello World',
                              expression: "'Hello World'"
                            }
                          ]
                        },
                        [_vm._v('Top')]
                      ),
                      _vm._v(' '),
                      _c(
                        'vk-button',
                        {
                          directives: [
                            {
                              name: 'vk-tooltip',
                              rawName: 'v-vk-tooltip.topLeft',
                              value: 'Hello World',
                              expression: "'Hello World'",
                              modifiers: { topLeft: true }
                            }
                          ]
                        },
                        [_vm._v('Top Left')]
                      ),
                      _vm._v(' '),
                      _c(
                        'vk-button',
                        {
                          directives: [
                            {
                              name: 'vk-tooltip',
                              rawName: 'v-vk-tooltip.topRight',
                              value: 'Hello World',
                              expression: "'Hello World'",
                              modifiers: { topRight: true }
                            }
                          ]
                        },
                        [_vm._v('Top Right')]
                      ),
                      _vm._v(' '),
                      _c(
                        'vk-button',
                        {
                          directives: [
                            {
                              name: 'vk-tooltip',
                              rawName: 'v-vk-tooltip.bottom',
                              value: 'Hello World',
                              expression: "'Hello World'",
                              modifiers: { bottom: true }
                            }
                          ]
                        },
                        [_vm._v('Bottom')]
                      ),
                      _vm._v(' '),
                      _c(
                        'vk-button',
                        {
                          directives: [
                            {
                              name: 'vk-tooltip',
                              rawName: 'v-vk-tooltip.bottomLeft',
                              value: 'Hello World',
                              expression: "'Hello World'",
                              modifiers: { bottomLeft: true }
                            }
                          ]
                        },
                        [_vm._v('Bottom Left')]
                      ),
                      _vm._v(' '),
                      _c(
                        'vk-button',
                        {
                          directives: [
                            {
                              name: 'vk-tooltip',
                              rawName: 'v-vk-tooltip.bottomRight',
                              value: 'Hello World',
                              expression: "'Hello World'",
                              modifiers: { bottomRight: true }
                            }
                          ]
                        },
                        [_vm._v('Bottom Right')]
                      ),
                      _vm._v(' '),
                      _c(
                        'vk-button',
                        {
                          directives: [
                            {
                              name: 'vk-tooltip',
                              rawName: 'v-vk-tooltip.left',
                              value: 'Hello World',
                              expression: "'Hello World'",
                              modifiers: { left: true }
                            }
                          ]
                        },
                        [_vm._v('Left')]
                      ),
                      _vm._v(' '),
                      _c(
                        'vk-button',
                        {
                          directives: [
                            {
                              name: 'vk-tooltip',
                              rawName: 'v-vk-tooltip.right',
                              value: 'Hello World',
                              expression: "'Hello World'",
                              modifiers: { right: true }
                            }
                          ]
                        },
                        [_vm._v('Right')]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(' '),
                _c('vk-tabs-item', { attrs: { title: 'Markup' } }, [
                  _c('pre', [
                    _c(
                      'code',
                      { staticClass: 'lang-html hljs', attrs: { id: '123' } },
                      [
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('p')
                          ]),
                          _vm._v(' '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v('v-vk-margin')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n  '),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-button')
                          ]),
                          _vm._v(' '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v('v-vk-tooltip')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"\'Hello World\'"')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('Top'),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-button')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n  '),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-button')
                          ]),
                          _vm._v(' '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v('v-vk-tooltip.topLeft')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"\'Hello World\'"')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('Top Left'),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-button')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n  '),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-button')
                          ]),
                          _vm._v(' '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v('v-vk-tooltip.topRight')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"\'Hello World\'"')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('Top Right'),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-button')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n  '),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-button')
                          ]),
                          _vm._v(' '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v('v-vk-tooltip.bottom')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"\'Hello World\'"')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('Bottom'),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-button')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n  '),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-button')
                          ]),
                          _vm._v(' '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v('v-vk-tooltip.bottomLeft')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"\'Hello World\'"')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('Bottom Left'),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-button')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n  '),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-button')
                          ]),
                          _vm._v(' '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v('v-vk-tooltip.bottomRight')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"\'Hello World\'"')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('Bottom Right'),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-button')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n  '),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-button')
                          ]),
                          _vm._v(' '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v('v-vk-tooltip.left')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"\'Hello World\'"')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('Left'),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-button')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n  '),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-button')
                          ]),
                          _vm._v(' '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v('v-vk-tooltip.right')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"\'Hello World\'"')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('Right'),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-button')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('\n'),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('p')
                          ]),
                          _vm._v('>')
                        ])
                      ]
                    )
                  ])
                ])
              ],
              1
            )
          ],
          1
        )
      },
      data: function() {
        return {}
      }
    },
    'md-code-example-124': {
      render: function render() {
        var _vm = this
        var _h = _vm.$createElement
        var _c = _vm._self._c || _h
        return _c(
          'div',
          { staticClass: 'uk-position-relative uk-margin-medium' },
          [
            _c(
              'vk-tabs',
              { staticClass: 'uk-margin' },
              [
                _c(
                  'vk-tabs-item',
                  { attrs: { title: 'Preview' } },
                  [
                    _c(
                      'vk-button',
                      {
                        directives: [
                          {
                            name: 'vk-tooltip',
                            rawName: 'v-vk-tooltip',
                            value: {
                              title: 'Hello World',
                              animation: 'scale-up fade',
                              duration: 300
                            },
                            expression:
                              "{ \n    title: 'Hello World', \n    animation: 'scale-up fade', \n    duration: 300\n  }"
                          }
                        ]
                      },
                      [_vm._v('\n  Hover\n')]
                    )
                  ],
                  1
                ),
                _vm._v(' '),
                _c('vk-tabs-item', { attrs: { title: 'Markup' } }, [
                  _c('pre', [
                    _c(
                      'code',
                      { staticClass: 'lang-html hljs', attrs: { id: '124' } },
                      [
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-button')
                          ]),
                          _vm._v(' \n  '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v('v-vk-tooltip')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v(
                              "\"{ \n    title: 'Hello World', \n    animation: 'scale-up fade', \n    duration: 300\n  }\""
                            )
                          ]),
                          _vm._v('\n>')
                        ]),
                        _vm._v('\n  Hover\n'),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-button')
                          ]),
                          _vm._v('>')
                        ])
                      ]
                    )
                  ])
                ])
              ],
              1
            )
          ],
          1
        )
      },
      data: function() {
        return {}
      }
    },
    'md-code-example-125': {
      render: function render() {
        var _vm = this
        var _h = _vm.$createElement
        var _c = _vm._self._c || _h
        return _c(
          'div',
          { staticClass: 'uk-position-relative uk-margin-medium' },
          [
            _c(
              'vk-tabs',
              { staticClass: 'uk-margin' },
              [
                _c(
                  'vk-tabs-item',
                  { attrs: { title: 'Preview' } },
                  [
                    _c(
                      'vk-button',
                      {
                        directives: [
                          {
                            name: 'vk-tooltip',
                            rawName: 'v-vk-tooltip',
                            value: { title: 'Hello World', delay: 500 },
                            expression: "{ title: 'Hello World', delay: 500 }"
                          }
                        ]
                      },
                      [_vm._v('Hover')]
                    )
                  ],
                  1
                ),
                _vm._v(' '),
                _c('vk-tabs-item', { attrs: { title: 'Markup' } }, [
                  _c('pre', [
                    _c(
                      'code',
                      { staticClass: 'lang-html hljs', attrs: { id: '125' } },
                      [
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('<'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-button')
                          ]),
                          _vm._v(' '),
                          _c('span', { staticClass: 'hljs-attr' }, [
                            _vm._v('v-vk-tooltip')
                          ]),
                          _vm._v('='),
                          _c('span', { staticClass: 'hljs-string' }, [
                            _vm._v('"{ title: \'Hello World\', delay: 500 }"')
                          ]),
                          _vm._v('>')
                        ]),
                        _vm._v('Hover'),
                        _c('span', { staticClass: 'hljs-tag' }, [
                          _vm._v('</'),
                          _c('span', { staticClass: 'hljs-name' }, [
                            _vm._v('vk-button')
                          ]),
                          _vm._v('>')
                        ])
                      ]
                    )
                  ])
                ])
              ],
              1
            )
          ],
          1
        )
      },
      data: function() {
        return {}
      }
    }
  }
}


export default Component
